import React from 'react';
export function FeaturesSection() {
  return <div className="max-w-3xl mx-auto px-5 md:px-6 py-10" data-id="element-119">
      <hr className="border-t-2 border-dashed border-border-light mb-10" data-id="element-120" />

      <h2 className="font-serif text-2xl md:text-3xl font-bold text-dark text-center mb-4" data-id="element-121">
        ¿Qué Hace "Perfecto" a Este Pack?
      </h2>
      <p className="text-center font-serif text-lg text-body-text mb-8 max-w-2xl mx-auto" data-id="element-122">
        Simplemente: debe ser tan detallado que no deje NADA a la improvisación,
        y tan simple que cualquier padre, abuelo o cuidador pueda usarlo. Debe
        contener instrucciones completas de principio a fin.
      </p>
      <p className="text-center font-serif text-lg text-body-text mb-10 max-w-2xl mx-auto" data-id="element-123">
        Mira las características y descubre por qué nuestras guías son{' '}
        <strong data-id="element-124">10 veces mejores</strong> que todo lo que encuentras gratis en
        internet:
      </p>

      {/* Feature 1 */}
      <div className="bg-white border border-[#e8e0d4] rounded-xl p-7 md:p-8 my-7 shadow-sm" data-id="element-125">
        <p className="font-sans text-sm uppercase tracking-[2px] text-primary font-bold mb-1" data-id="element-126">
          Característica #1
        </p>
        <p className="text-4xl mb-3" data-id="element-127">📋</p>
        <h3 className="font-sans text-xl md:text-2xl font-extrabold text-dark mb-3" data-id="element-128">
          Actividades Mes a Mes, Paso a Paso
        </h3>
        <p className="font-serif text-base text-body-text mb-3 leading-relaxed" data-id="element-129">
          Recibes actividades detalladas organizadas{' '}
          <strong data-id="element-130">por cada mes de vida</strong>, de la A a la Z, con
          instrucciones que hacen que estimular a tu hijo sea{' '}
          <strong data-id="element-131">súper rápido, súper fácil y súper divertido</strong>.
        </p>
        <p className="font-serif text-base text-body-text mb-3 leading-relaxed" data-id="element-132">
          Con instrucciones sencillas que te{' '}
          <strong data-id="element-133">"llevan de la mano"</strong>, puedes completar cada actividad
          en una fracción del tiempo que actualmente dedicas buscando qué hacer.
        </p>
        <p className="font-serif text-base text-body-text leading-relaxed" data-id="element-134">
          Es como tener a una{' '}
          <strong data-id="element-135">ESPECIALISTA EN DESARROLLO INFANTIL</strong> a tu lado,
          guiándote en cada ejercicio.
        </p>
      </div>

      {/* Feature 2 */}
      <div className="bg-white border border-[#e8e0d4] rounded-xl p-7 md:p-8 my-7 shadow-sm" data-id="element-136">
        <p className="font-sans text-sm uppercase tracking-[2px] text-primary font-bold mb-1" data-id="element-137">
          Característica #2
        </p>
        <p className="text-4xl mb-3" data-id="element-138">🏠</p>
        <h3 className="font-sans text-xl md:text-2xl font-extrabold text-dark mb-3" data-id="element-139">
          Materiales Que Ya Tienes en Casa
        </h3>
        <p className="font-serif text-base text-body-text mb-3 leading-relaxed" data-id="element-140">
          Cada actividad incluye la{' '}
          <strong data-id="element-141">lista EXACTA de materiales necesarios</strong> — y la gran
          mayoría son cosas que ya tienes en tu hogar.
        </p>
        <p className="font-serif text-base text-body-text mb-3 leading-relaxed" data-id="element-142">
          Dejarás de gastar dinero en juguetes caros que no sirven, en
          materiales equivocados o en recursos que no son apropiados para la
          edad. <strong data-id="element-143">Se acabó el desperdicio.</strong>
        </p>
        <p className="font-serif text-base text-body-text leading-relaxed" data-id="element-144">
          Ahorras tiempo, ahorras dinero. Pasarás más tiempo CONECTANDO con tu
          hijo/a y menos tiempo estresándote.
        </p>
      </div>

      {/* Feature 3 */}
      <div className="bg-white border border-[#e8e0d4] rounded-xl p-7 md:p-8 my-7 shadow-sm" data-id="element-145">
        <p className="font-sans text-sm uppercase tracking-[2px] text-primary font-bold mb-1" data-id="element-146">
          Característica #3
        </p>
        <p className="text-4xl mb-3" data-id="element-147">🧠</p>
        <h3 className="font-sans text-xl md:text-2xl font-extrabold text-dark mb-3" data-id="element-148">
          Todas las Áreas de Desarrollo Cubiertas
        </h3>
        <p className="font-serif text-base text-body-text mb-3 leading-relaxed" data-id="element-149">
          Cada guía incluye actividades para{' '}
          <strong data-id="element-150">TODAS las áreas clave</strong>: motricidad fina, motricidad
          gruesa, lenguaje, cognición, desarrollo sensorial y socioemocional.
        </p>
        <p className="font-serif text-base text-body-text mb-3 leading-relaxed" data-id="element-151">
          Cuando la estimulación es ESTA completa, el desarrollo de tu hijo{' '}
          <strong data-id="element-152">se potencia solo</strong>. Todas las piezas simplemente
          "encajan".
        </p>
        <p className="font-serif text-base text-body-text leading-relaxed" data-id="element-153">
          Verás avances en una fracción del tiempo que normalmente tardarías
          improvisando.
        </p>
      </div>

      {/* Feature 4 */}
      <div className="bg-white border border-[#e8e0d4] rounded-xl p-7 md:p-8 my-7 shadow-sm" data-id="element-154">
        <p className="font-sans text-sm uppercase tracking-[2px] text-primary font-bold mb-1" data-id="element-155">
          Característica #4
        </p>
        <p className="text-4xl mb-3" data-id="element-156">📱</p>
        <h3 className="font-sans text-xl md:text-2xl font-extrabold text-dark mb-3" data-id="element-157">
          100% Sin Pantallas · Guías Imprimibles en PDF
        </h3>
        <p className="font-serif text-base text-body-text mb-3 leading-relaxed" data-id="element-158">
          Puedes VER exactamente qué hacer <strong data-id="element-159">ANTES de hacerlo</strong> —
          imprime las guías y tenlas siempre a mano.
        </p>
        <p className="font-serif text-base text-body-text mb-3 leading-relaxed" data-id="element-160">
          La mayoría de recursos online te obligan a tener el móvil delante del
          niño. Aquí NO. Imprimes, guardas el teléfono y{' '}
          <strong data-id="element-161">conectas de verdad</strong>.
        </p>
        <p className="font-serif text-base text-body-text leading-relaxed" data-id="element-162">
          Las guías NUNCA te dejarán con dudas ni rascándote la cabeza sobre qué
          hacer a continuación.
        </p>
      </div>

      {/* Feature 5 */}
      <div className="bg-white border border-[#e8e0d4] rounded-xl p-7 md:p-8 my-7 shadow-sm" data-id="element-163">
        <p className="font-sans text-sm uppercase tracking-[2px] text-primary font-bold mb-1" data-id="element-164">
          Característica #5
        </p>
        <p className="text-4xl mb-3" data-id="element-165">👶</p>
        <h3 className="font-sans text-xl md:text-2xl font-extrabold text-dark mb-3" data-id="element-166">
          Para Padres Primerizos y Experimentados
        </h3>
        <p className="font-serif text-base text-body-text mb-3 leading-relaxed" data-id="element-167">
          Tenemos actividades que cubren <strong data-id="element-168">TODOS los niveles</strong>. NO
          necesitas ser pedagogo, tener experiencia previa ni comprar materiales
          costosos.
        </p>
        <p className="font-serif text-base text-body-text mb-3 leading-relaxed" data-id="element-169">
          Ya seas un padre primerizo con su recién nacido, un abuelo que cuida a
          sus nietos, o un educador con años de experiencia, encontrarás{' '}
          <strong data-id="element-170">cientos de actividades perfectas para tu situación</strong>.
        </p>
        <p className="font-serif text-base text-body-text leading-relaxed" data-id="element-171">
          La colección completa cubre desde juegos sensoriales para recién
          nacidos hasta actividades pre-escolares avanzadas.{' '}
          <strong data-id="element-172">¡Hay algo para todos!</strong>
        </p>
      </div>

      {/* Stats Bar */}
      <div className="flex justify-center gap-6 md:gap-10 flex-wrap text-center my-10 py-7 px-5 bg-dark rounded-xl" data-id="element-173">
        <div data-id="element-174">
          <p className="font-sans text-3xl md:text-4xl font-black text-accent" data-id="element-175">
            1.000+
          </p>
          <p className="font-sans text-xs md:text-sm text-gray-400 uppercase tracking-wider" data-id="element-176">
            Actividades Planeadas
          </p>
        </div>
        <div data-id="element-177">
          <p className="font-sans text-3xl md:text-4xl font-black text-accent" data-id="element-178">
            0 a 60
          </p>
          <p className="font-sans text-xs md:text-sm text-gray-400 uppercase tracking-wider" data-id="element-179">
            Meses Cubiertos
          </p>
        </div>
        <div data-id="element-180">
          <p className="font-sans text-3xl md:text-4xl font-black text-accent" data-id="element-181">
            6
          </p>
          <p className="font-sans text-xs md:text-sm text-gray-400 uppercase tracking-wider" data-id="element-182">
            Áreas de Desarrollo
          </p>
        </div>
        <div data-id="element-183">
          <p className="font-sans text-3xl md:text-4xl font-black text-accent" data-id="element-184">
            10 min
          </p>
          <p className="font-sans text-xs md:text-sm text-gray-400 uppercase tracking-wider" data-id="element-185">
            Al Día Es Suficiente
          </p>
        </div>
      </div>
    </div>;
}